import jQuery from 'jquery';

const Drupal = window.Drupal;
const once = window.once;

(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.newsSlider = {
    attach: function(context) {
      once('card-carousel', context.querySelectorAll('.view-in-the-news .view-content'))
        .forEach(function(element) {
          jQuery(element).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
            nextArrow: '<button type="button" class="slick-next">&gt;</button>'
          });
        });
    }
  };

  Drupal.behaviors.artifactSlider = {
    attach: function(context) {
      once('card-carousel', context.querySelectorAll('.field--name-field-artifact-items'))
        .forEach(function(element) {
          jQuery(element).slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            prevArrow: '<button type="button" class="slick-prev">&lt;</button>',
            nextArrow: '<button type="button" class="slick-next">&gt;</button>',
            responsive: [
              { breakpoint: 1200, settings: { slidesToShow: 3 } },
              { breakpoint: 768, settings: { slidesToShow: 2 } },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  centerMode: true,
                  centerPadding: '20px'
                }
              }
            ]
          });
        });
    }
  };

  Drupal.behaviors.mastheadSlider = {
    attach: function(context) {
      once('card-carousel', context.querySelectorAll('.views-field-field-masthead-image .field-content'))
        .forEach(function(element) {
          jQuery(element).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            autoplay: true,
            autoplaySpeed: 5000,
            cssEase: 'linear',
            arrows: false
          });
        });
    }
  };

})(jQuery, Drupal);
